var map = {
	"./active.svg": "90fa",
	"./archive.svg": "6ff0",
	"./arrow-down.svg": "b910",
	"./arrow-left.svg": "c633",
	"./arrow-right.svg": "2a29",
	"./arrow-up.svg": "3cdf",
	"./assignment.svg": "187d",
	"./balance.svg": "074c",
	"./bell.svg": "3cc2",
	"./book.svg": "d0ad",
	"./calculator.svg": "859c",
	"./calendar.svg": "aa21",
	"./camera.svg": "b3c4",
	"./cancel-license.svg": "5a47",
	"./cancel.svg": "ad05",
	"./caret-down.svg": "39a4",
	"./caret-left.svg": "d480",
	"./caret-right.svg": "4cb6",
	"./caret-up.svg": "0ce2",
	"./case-study.svg": "a8d3",
	"./change-password.svg": "fb51",
	"./check.svg": "bc4a",
	"./checked.svg": "8867",
	"./close.svg": "e67b",
	"./connection.svg": "fafb",
	"./database.svg": "2d20",
	"./delete.svg": "b248",
	"./digital-signature.svg": "1271",
	"./edit-license.svg": "7fe8",
	"./edit.svg": "f232",
	"./error_red_icon.svg": "b22e",
	"./event.svg": "d2c9",
	"./eye.svg": "ff6e",
	"./fee.svg": "c901",
	"./file-csv.svg": "165e",
	"./fisher-man.svg": "f34a",
	"./fisherman.svg": "2e82",
	"./fishing-boat.svg": "b87a",
	"./fishing-tool.svg": "45e8",
	"./folder.svg": "2a33",
	"./folders.svg": "c8afc",
	"./home.svg": "7e04",
	"./information.svg": "2e17",
	"./informative.svg": "8ac8",
	"./invoice.svg": "bfb3",
	"./language.svg": "8767",
	"./law.svg": "4067",
	"./license.svg": "9fdf",
	"./log-file.svg": "507d",
	"./login.svg": "546b",
	"./logout.svg": "9629",
	"./manager.svg": "e593",
	"./map.svg": "8d3c",
	"./menu-side.svg": "ae68",
	"./menu.svg": "b778",
	"./my-job.svg": "5534",
	"./not-found.svg": "c1da",
	"./org-chart.svg": "4fa6",
	"./password.svg": "3bae",
	"./pdf.svg": "ad90",
	"./plus.svg": "871b",
	"./poll-answer.png": "53ea",
	"./poll-answer.svg": "1808",
	"./polling.svg": "dc90",
	"./printer.svg": "938c",
	"./profile.svg": "b8d1",
	"./qa-color.svg": "75357",
	"./qa.svg": "4126",
	"./rate.svg": "8b8a",
	"./refresh.svg": "94cf",
	"./register.svg": "0455",
	"./renew-license.svg": "4101",
	"./replace-license.svg": "0f23",
	"./report.svg": "b950",
	"./request-license.svg": "c9f6",
	"./request.svg": "e1b1",
	"./reset.svg": "8231",
	"./resource.svg": "19fd",
	"./resume.svg": "9bd1",
	"./role.svg": "c74c",
	"./save.svg": "5cb3",
	"./search.svg": "08e1",
	"./select.svg": "fcc9",
	"./setting.svg": "afae",
	"./settings.svg": "1f0e",
	"./state.svg": "da2e",
	"./statistics.svg": "5c61",
	"./team.svg": "08d7",
	"./teamwork.svg": "b56f",
	"./toggle-sidebar-left.svg": "cfd9",
	"./toggle-sidebar-right.svg": "b959",
	"./transfer-license.svg": "4f7e",
	"./upload.svg": "93a9",
	"./user-transfer.svg": "acf8",
	"./user.svg": "d710",
	"./username.svg": "fb73",
	"./waiting.svg": "f9f1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8873";